<section>
  <header>
    <h1>Signalements</h1>
    <button (click)="reload(currentPage)">Rafraîchir</button>
  </header>

  <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>

  <div class="toolbar" *ngIf="!accessDenied">
    <input
      type="search"
      [value]="searchQuery"
      (input)="applySearch(($any($event.target).value || '').toString())"
      placeholder="Rechercher..."
    />
  </div>

  <div class="state loading-state" *ngIf="loading">
    <span class="spinner" aria-hidden="true"></span>
    <span>Chargement…</span>
  </div>

  <div class="state" *ngIf="!loading && accessDenied">
    Accès réservé aux administrateurs/managers pour la gestion des signalements.
  </div>

  <div class="state" *ngIf="!loading && !accessDenied && reports.length === 0">Aucun signalement ouvert.</div>

  <table *ngIf="!loading && !accessDenied && reports.length > 0">
    <thead>
      <tr>
        <th>ID</th>
        <th>Cible</th>
        <th>Raison</th>
        <th>Statut</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let report of reports">
        <td>#{{ report.id }}</td>
        <td>{{ report.targetType }} / {{ report.targetId }}</td>
        <td>{{ report.reason }}</td>
        <td>{{ report.status }}</td>
        <td>
          <button class="warn" (click)="decide(report, 'WARN_USER')">Avertir</button>
          <button class="ok" (click)="decide(report, 'REMOVE_CONTENT')">Retirer contenu</button>
          <button class="ko" (click)="decide(report, 'SUSPEND_ACCOUNT')">Suspendre</button>
          <button class="ghost" (click)="decide(report, 'IGNORE')">Ignorer</button>
        </td>
      </tr>
    </tbody>
  </table>

  <footer class="pagination" *ngIf="!loading && !accessDenied">
    <span>{{ totalItems }} résultat(s)</span>
    <div>
      <button type="button" class="ghost" (click)="previousPage()" [disabled]="currentPage === 0">Préc.</button>
      <span>Page {{ currentPage + 1 }} / {{ totalPages }}</span>
      <button type="button" class="ghost" (click)="nextPage()" [disabled]="currentPage + 1 >= totalPages">Suiv.</button>
    </div>
  </footer>
</section>
